export const skillsArray = [
    {
        id: 1,
        parentSkillTitle: 'Front End',
        skills: [
            {
                id: 1,
                skillTitle: 'HTML',
                skillImgSrc: '/front-end/html.svg'
            },
            {
                id: 2,
                skillTitle: 'CSS',
                skillImgSrc: '/front-end/css.svg'
            },
            {
                id: 3,
                skillTitle: 'Javascript',
                skillImgSrc: '/front-end/javascript.svg'
            },
            {
                id: 4,
                skillTitle: 'React',
                skillImgSrc: '/front-end/react.svg'
            },
            {
                id: 5,
                skillTitle: 'Sass',
                skillImgSrc: '/front-end/sass.svg'
            }
        ]
    },
    {
        id: 2,
        parentSkillTitle: 'Back End',
        skills: [
            {
                id: 1,
                skillTitle: 'C/C++',
                skillImgSrc: '/back-end/c++.svg'
            },
            {
                id: 2,
                skillTitle: 'Java',
                skillImgSrc: '/back-end/java.svg'
            },
            {
                id: 3,
                skillTitle: 'Python',
                skillImgSrc: '/back-end/python.svg'
            },
            {
                id: 4,
                skillTitle: 'PHP',
                skillImgSrc: '/back-end/php.svg'
            },
            {
                id: 5,
                skillTitle: 'Node',
                skillImgSrc: '/back-end/node.svg'
            },
            {
                id: 6,
                skillTitle: 'Laravel',
                skillImgSrc: '/back-end/laravel.svg'
            },
            {
                id: 7,
                skillTitle: 'Express',
                skillImgSrc: '/back-end/express.svg'
            },
            {
                id: 8,
                skillTitle: 'Bash',
                skillImgSrc: '/back-end/bash.svg'
            }
        ]
    },
    {
        id: 3,
        parentSkillTitle: 'Databases',
        skills: [
            {
                id: 1,
                skillTitle: 'MySQL',
                skillImgSrc: '/databases/mysql.svg'
            },
            {
                id: 2,
                skillTitle: 'PostgreSQL',
                skillImgSrc: '/databases/postgresql.svg'
            },
            {
                id: 3,
                skillTitle: 'Mongo DB',
                skillImgSrc: '/databases/mongodb.svg'
            },
            {
                id: 4,
                skillTitle: 'Dynamo DB',
                skillImgSrc: '/databases/dynamodb.svg'
            },
            {
                id: 4,
                skillTitle: 'Redis',
                skillImgSrc: '/databases/redis.svg'
            }
            
        ]
    }
]